export default __webpack_public_path__ + "static/media/deliveries_13.db6a12ef.png";